/**
 * El bloque que se mete a mitad de cada post del blog. FUENTE UNICA: lo
 * consumen `src/pages/Blogpost.jsx` (lo que ve el lector) y
 * `scripts/prerender-meta.js` (el HTML que ve Google sin JS), igual que
 * `relacionados.js`.
 *
 * POR QUE ENLAZA A /app-para-contar-calorias-con-foto (24-sep): en Search
 * Console las paginas de app convierten 10 veces mas que el blog (2,5 % de CTR
 * frente al 0,1-0,7 %) y son las unicas con busquedas de quien quiere una app,
 * pero estaban en posicion 8-10 sin casi enlaces internos. Antes este bloque
 * solo existia en React y mandaba los 77 posts a dos articulos concretos, justo
 * la concentracion de enlaces que `relacionados.js` quito el 8-sep.
 */
export const MID_ARTICLE_CTA = `
  <div class="cta-box">
    <h3>Si no quieres calcularlo a mano</h3>
    <p>Hazle una foto al plato y te dice las calorías y los macros al momento. Es lo que hace Wayo, nuestra <a href="/app-para-contar-calorias-con-foto">app para contar calorías con foto</a>, y puedes probarla gratis.</p>
    <p><a href="https://wayoai.app/download" class="cta-button">Descargar Wayo Gratis</a></p>
  </div>
`;

export function injectMidArticleCta(content) {
  if (!content) return content;

  const withoutExistingCtas = content.replace(/\s*<div class="cta-box">[\s\S]*?<\/div>\s*/gi, "\n");
  const h2Matches = [...withoutExistingCtas.matchAll(/<h2\b[^>]*>/gi)];

  if (h2Matches.length >= 2) {
    const middleHeading = h2Matches[Math.floor(h2Matches.length / 2)];
    return `${withoutExistingCtas.slice(0, middleHeading.index)}${MID_ARTICLE_CTA}\n${withoutExistingCtas.slice(middleHeading.index)}`;
  }

  const paragraphMatches = [...withoutExistingCtas.matchAll(/<\/p>/gi)];
  if (paragraphMatches.length >= 4) {
    const middleParagraph = paragraphMatches[Math.floor(paragraphMatches.length / 2) - 1];
    const insertIndex = middleParagraph.index + middleParagraph[0].length;
    return `${withoutExistingCtas.slice(0, insertIndex)}\n${MID_ARTICLE_CTA}\n${withoutExistingCtas.slice(insertIndex)}`;
  }

  const lastWrapperClose = withoutExistingCtas.lastIndexOf("</div>");
  if (lastWrapperClose !== -1) {
    return `${withoutExistingCtas.slice(0, lastWrapperClose)}\n${MID_ARTICLE_CTA}\n${withoutExistingCtas.slice(lastWrapperClose)}`;
  }

  return `${withoutExistingCtas}\n${MID_ARTICLE_CTA}`;
}
